<!--
* @Description:相关调研4
* @Date: 2024-01-20 09:33:01
-->
<template>
  <div
    class="patient-sex"
    ref="TaskRef"
    :style="{
      transform: `scale(${scale})`,
      transformOrigin: '0 0'
    }"
  >
    <div class="contnet" ref="ContentRef">
      <div
        style="
          height: 500px;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <div class="contnet-warp">
          <div
            class="contnet-warp-item"
            v-for="(item, index) in data.tipData"
            :key="index"
            :style="{
              '--color': `var(--theme-color-${index + 1},#000)`,
              '--zindex': `${item[item.length - 1]}`,
              '--left': `${(index + 1) % 2 == 0 ? '-302px' : '184px'}`,
              '--lineLeft': `${(index + 1) % 2 == 0 ? '188px' : '-94px'}`,
              '--afterRight': `${(index + 1) % 2 == 0 ? '84px' : '-5px'}`
            }"
          >
            <div class="content-warp-item-left">
              <div class="top"></div>
              <div class="content"></div>
              <div class="bottom"></div>
            </div>
            <div class="content-warp-item-right">
              <div class="content-warp-item-right-bg"></div>
              <div class="content-warp-item-right-text">
                <div class="content-warp-item-right-text-line"></div>
                <div class="content-warp-item-right-text-inner">
                  <div>
                    <div
                      v-for="(item2, index2) in item.slice(0, item.length - 1)"
                      :key="index2"
                    >
                      {{ item2.label }}：{{ item2.value }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="content-name">
        <div>
          <div
            :style="{ '--color': `var(--theme-color-${index + 1},#000)` }"
            v-for="(item, index) in data.projectName"
            :key="index"
          >
            <div></div>
            <div>{{ item.value }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, defineProps } from 'vue';
import { selfAdaption, useDataAssembly } from './hooks';
const props = defineProps<{
  tableHeaderList: Array<{ label: Array<string>; prop: string }>;
  tableDataList: Array<{ [key: string]: Array<string> }>;
}>();
const TaskRef = ref<HTMLDivElement>();
const ContentRef = ref<HTMLDivElement>();
const scale = ref(1);
onMounted(async () => {
  await selfAdaption(TaskRef, ContentRef, scale);
});

let data = useDataAssembly(props.tableHeaderList, props.tableDataList);
let zindex = 6;
data.value.tipData.forEach(item => {
  item.push(zindex--);
});
</script>

<style lang="scss" scoped>
@import './index.scss';
.patient-sex {
  @include patientSex();
  .contnet {
    @include content();
    position: relative;
    margin-top: 47px;
    display: flex;
    justify-content: center;
    .contnet-warp {
      margin-top: 47px;
      margin: auto;
      width: 70px;
      position: relative;
      .contnet-warp-item {
        margin-top: -5px;
        height: 75px;
        width: 373.66px;
        display: flex;
        &:nth-child(even) {
          position: relative;
        }
        .content-warp-item-left {
          z-index: var(--zindex);
          width: 9px;
          height: 100%;
          position: relative;
          display: flex;
          .top {
            z-index: 4;
            position: absolute;
            width: 90px;
            height: 32px;
            border-radius: 100%;
            background-color: var(--color);
            border: 1px solid #fff;
          }
          .content {
            z-index: 3;
            position: absolute;
            top: 16px;
            width: 90px;
            height: 44px;
            background-color: var(--color);
          }
          .bottom {
            z-index: 2;
            position: absolute;
            width: 91.05px;
            margin-left: -0.5px;
            height: 32px;
            border-radius: 100%;
            bottom: 0;
            background-color: var(--color);
            border: 1px solid #fff;
          }
        }
        .content-warp-item-right {
          left: var(--left);
          width: 189.66px;
          height: 20px;
          position: relative;
          margin-top: 20px;
          .content-warp-item-right-bg {
            opacity: $--opacityText;
            background-color: var(--color);
            position: absolute;
            width: 189.66px;
            height: 117px;
            border-radius: 12px;
          }
          .content-warp-item-right-text {
            position: absolute;
            width: 189.66px;
            height: 117px;
            border: 1px solid var(--color);
            border-radius: 12px;
            .content-warp-item-right-text-line {
              margin-top: 20px;
              left: var(--lineLeft);
              position: absolute;
              content: '';
              width: 94px;
              height: $--tipsLine;
              background-color: var(--color);
              &::after {
                left: var(--afterRight);
                content: '';
                position: absolute;
                width: 14px;
                height: 14px;
                border-radius: 100%;
                transform: translateY(-40%);
                background-color: var(--color);
              }
            }
            .content-warp-item-right-text-inner {
              width: 100%;
              height: 100%;
              position: absolute;
              display: flex;
              align-items: center;
              justify-content: center;
              > div {
                @include text();
              }
            }
          }
        }
      }
    }
    .content-name {
      position: absolute;
      bottom: 0;
      margin-top: 50px;
      height: 100px;
      width: 100%;
      display: flex;
      justify-content: center;
      > div {
        display: flex;
        width: 80%;
        justify-content: center;

        > div {
          margin: 0 10px;
          display: flex;
          width: 100%;
          > div:nth-child(1) {
            margin-right: 5px;
            width: 21px;
            height: 21px;
            background-color: var(--color);
          }
          > div:nth-child(2) {
            @include bottomText();
          }
        }
      }
    }
  }
}
</style>
